import React, { useState } from "react";
import { Button } from "react-bootstrap";
import TutorialModal from "../../../../TutorialModal/TutorialModal";

const IntroMessages = () => {
  const [showModal, setShowModal] = useState(false); // Start with tutorial closed
  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);

  return (
    <>
      <TutorialModal show={showModal} handleClose={handleModalClose} />

      <Button
        variant="dark"
        onClick={handleModalShow}
        style={{ width: "fit-content", padding: "10px 20px", margin: "5px 0" }}
      >
        View Tutorial
      </Button>

      <div className="message assistant">
        If you're new here, click the button below to view a short tutorial.
      </div>

      <div className="message assistant">
        I'm here to assist you in modeling business processes. Describe your
        process and I will create a BPMN model for you! I will then ask for your
        feedback to finalize the model step by step.
      </div>

      <div className="message assistant">
        Hello! Welcome, I'm the BPMN-Chatbot.
      </div>
    </>
  );
};

export default IntroMessages;
